import axiosInstance from "@/api/axios-instance";

export async function updateTotalSessions(
  usage_id: string,
  new_total_session_quantity: number
) {
  const response = await axiosInstance.patch("/usage/update-total", {
    usage_id,
    new_total_session_quantity,
  });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("failed updating total session quantity");
  }

  return response.data;
}
